import BtnPrimary from '../ui/BtnPrimary';
import BtnGhost from '../ui/BtnGhost';
import HeroImage from "../../assets/photos/10.jpg";
import { useAppContext } from '../../context/AppContext';
import { LandingTrans } from '../../utils/translations';

export default function Hero({ onLearnMore, onSignUp }) {
  const { language } = useAppContext();
  const t = LandingTrans[language];
  const stats = [
    { value: '3+', label: t.statYears },
    { value: '4', label: t.statFormats },
    { value: '50₪', label: t.statFirstClass },
  ];

  return (
    <section className="landing-hero-section grid grid-cols-1 md:grid-cols-2 pt-20 bg-cream relative max-md:overflow-x-hidden md:overflow-hidden pb-10 md:pb-0">
      <div
        className="absolute top-0 right-0 bottom-0 w-1/2 hidden md:block pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 60% 80% at 70% 50%, rgba(193,123,92,0.08), transparent)',
        }}
      />

      <div className="pl-6 pr-6 md:pl-20 md:pr-16 md:py-20 flex flex-col justify-center order-2 md:order-1">
        <div
          className="animate-fade-up flex items-center gap-3 mb-6"
          style={{ animationDelay: '0.1s' }}
        >
          <span className="w-8 h-px bg-clay flex-shrink-0" />
          <span className="text-eyebrow font-sans font-normal uppercase tracking-[0.18em] text-clay">
            {t.heroEyebrow}
          </span>
        </div>

        <h1
          className="font-serif text-ink mb-6 animate-fade-up"
          style={{
            fontSize: 'clamp(52px, 7vw, 88px)',
            lineHeight: 1.1,
            fontWeight: 500,
            animationDelay: '0.25s',
          }}
        >
          {t.heroTitle}<em className="italic text-clay font-serif">{t.heroTitleMat}</em>
        </h1>

        <p
          className="text-base font-sans font-light text-ink-mid max-w-sm mb-8 animate-fade-up"
          style={{ animationDelay: '0.4s' }}
        >
          {t.heroSubtitle}
        </p>

        <div
          className="flex flex-wrap gap-4 animate-fade-up"
          style={{ animationDelay: '0.55s' }}
        >
          <BtnPrimary onClick={onSignUp}>{t.signUpClass}</BtnPrimary>
          <BtnGhost onClick={onLearnMore}>{t.learnMore}</BtnGhost>
        </div>

        <div
          className="mt-16 pt-10 border-t border-sand-dark grid grid-cols-3 gap-6 animate-fade-up"
          style={{ animationDelay: '0.55s' }}
        >
          {stats.map(({ value, label }) => (
            <div key={label}>
              <p className="font-serif text-4xl font-normal text-clay">{value}</p>
              <p className="text-xs font-sans font-light text-ink-light mt-1">{label}</p>
            </div>
          ))}
        </div>
      </div>

      <div
        className="relative landing-hero-image-shell order-1 md:order-2 bg-gradient-to-br from-sand via-clay-light to-cream"
        style={{ background: 'linear-gradient(135deg, #E8DDD0, #E8C4B0, #F5F0E8)' }}
      >
        <img
          src={HeroImage}
          alt={t.yogaAlt}
          className="w-full h-full object-cover max-md:object-[center_22%] md:object-top"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
        <div className="absolute top-4 right-4 md:top-auto md:right-auto md:bottom-6 md:left-6 bg-white rounded-sm shadow-lg p-2.5 max-w-[120px] md:p-4 md:max-w-[200px]">
          <p className="text-[10px] md:text-xs font-sans text-ink-mid">📍 {t.heroLocation}</p>
          <p className="font-serif text-sm md:text-lg font-medium text-ink mt-0.5 md:mt-1">{t.heroAddress}</p>
        </div>
      </div>
    </section>
  );
}
